import { render, staticRenderFns } from "./thridPartyAgreement.vue?vue&type=template&id=6a0cdd36&scoped=true"
import script from "./thridPartyAgreement.vue?vue&type=script&lang=js"
export * from "./thridPartyAgreement.vue?vue&type=script&lang=js"
import style0 from "./thridPartyAgreement.vue?vue&type=style&index=0&id=6a0cdd36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0cdd36",
  null
  
)

export default component.exports